import { createContext } from "react";

export const StepperContext = createContext(null);

